import { z } from "zod";

export const ContactMetaSchema = z.object({
  preferred_name: z.string().optional(),
  clients: z.array(z.string()).default([]),
});
